export default __webpack_public_path__ + "static/media/06.4cad5ff0.png";